// Shared permission key list + human labels. Used by PermissionsTab,
// DocumentsTab (for action-icon gating), and any code that mirrors the
// backend PERMISSION_KEYS list in core/config.py.
export const PERMISSION_KEYS = [
  "fence",
  "view",
  "encrypted",
  "pdf",
  "original",
  "upload",
  "manage",
];

export const PERMISSION_LABELS = {
  fence:     { label: "Fence View",      hint: "Watermarked, view-only preview in the browser (no zoom on text)" },
  view:      { label: "View",            hint: "Open the document in the in-browser viewer" },
  encrypted: { label: "Encrypted PDF",   hint: "Download a watermarked, view-only PDF (no edit / no copy / no high-res print)" },
  pdf:       { label: "Flat PDF",        hint: "Download a clean, locked PDF copy (no watermark)" },
  original:  { label: "Original",        hint: "Download the original/source file" },
  upload:    { label: "Upload",          hint: "Upload new files into this scope" },
  manage:    { label: "Manage",          hint: "Rename, move, delete, set access" },
};
